import {
    // Page,
    Text,
    View
} from '@react-pdf/renderer';

import { styles } from '../styles/styles';

import { useSystemUtils } from '../../../../hooks/useSystemUtils'
import { useDocumentAdjustments, adjustmentTypes } from '../../../../hooks/state/useDocumentAdjustments';

export function BodyMainFooterStyle1(props) {

    const {
        data,
        summary
    } = props

    const totalQty = summary?.totalQty ? summary.totalQty.toFixed(2) : 0.00

    return (
        <View
            style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
                alignItems: 'center',
                // paddingVertical: 8,
                paddingTop: 5,
                // paddingBottom: 3,
                // paddingBottom: 10,
                // paddingVertical: 10,
                borderTopColor: '#000',
                borderTopStyle: 'solid',
                borderTopWidth: 1,
            }}
        >
            <View style={{ width: '50%' }}>
                <></>
            </View>
            <View style={{ width: '39%' }}>
                <Text style={[styles.textBold, styles.h10, styles.textUpperCase, {}]}>Total</Text>
            </View>
            <View style={{ width: '10%' }}>
                <Text style={[styles.textBold, styles.h10, {}]}>{totalQty}</Text>
            </View>
            {/* {
                row.map((i, index) => {
                    return (
                        <View 
                            key={index}
                            style={{
                                width: tableFields[index].width,
                                textAlign: tableFields[index]?.align? tableFields[index].align: ''
                            }}
                        >
                            <Text style={[styles.h10, { fontWeight: 800 } ]}>{i}</Text>
                        </View>
                    )
                })
            } */}
        </View>
    )

}

export function BodyMainFooterStyle2(props) {

    const {
        data,
        summary
    } = props

    const totalQty = summary?.totalQty ? summary.totalQty.toFixed(2) : 0.00

    return (
        <View
            style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
                alignItems: 'center',
                // paddingVertical: 8,
                paddingTop: 5,
                // paddingBottom: 3,
                // paddingBottom: 10,
                // paddingVertical: 10,
                borderTopColor: '#000',
                borderTopStyle: 'solid',
                borderTopWidth: 1,
            }}
        >
            <View style={{ width: '40%' }}>
                <></>
            </View>
            <View style={{ width: '12%' }}>
                <Text style={[styles.textBold, styles.h10, styles.textUpperCase, {}]}>Total</Text>
            </View>
            <View style={{ width: '48%' }}>
                <Text style={[styles.textBold, styles.h10, {}]}>{totalQty}</Text>
            </View>
            {/* {
                row.map((i, index) => {
                    return (
                        <View 
                            key={index}
                            style={{
                                width: tableFields[index].width,
                                textAlign: tableFields[index]?.align? tableFields[index].align: ''
                            }}
                        >
                            <Text style={[styles.h10, { fontWeight: 800 } ]}>{i}</Text>
                        </View>
                    )
                })
            } */}
        </View>
    )
}

// with tax and discounts
export function BodyMainFooterStyle3(props) {

    const { currencyAbb, formatCurrencyDisplay } = useSystemUtils()

    const {
        data,
        document,
        summary
    } = props

    const totalQty = summary?.totalQty ? summary.totalQty.toFixed(2) : 0.00

    // console.log('totalQty', document)

    const {
        sub_total_amount: subTotal,
        total_amount: totalAmount,
        tax_amount: taxAmount,
        tax_description: taxDescription,
        discount_amount: discountAmount,
        adjustments = []
    } = document

    // console.log("Adjustment", adjustments)

    let adjustmentDiscountInfo = []
    let adjustmentTaxInfo = []

    adjustments.forEach(i => {
        if (i.type === adjustmentTypes.tax) {
            adjustmentTaxInfo.push({
                taxId: i.id,
                taxDescription: i.description,
                taxAmount: parseFloat(i.adjustment_amount).toFixed(2)
            })
        }
        else if (i.type === adjustmentTypes.discount) {
            adjustmentDiscountInfo.push({
                discountId: i.id,
                discountDescription: i.description,
                discountAmount: parseFloat(i.adjustment_amount).toFixed(2)
            })
        }
    })

    return (
        <View
            style={{
                paddingTop: 5,
                // paddingBottom: 3,
                // paddingBottom: 10,
                // paddingVertical: 10,
                borderTopColor: '#000',
                borderTopStyle: 'solid',
                borderTopWidth: 1,
            }}
        >
            {/* <View
                style={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    // paddingVertical: 8,
                }}
            >
                <View style={{ width: '70%' }}>
                    <></>
                </View>
                <View style={{ width: '19%' }}>
                    <Text style={[styles.h10, styles.textUpperCase, {}]}>Sub Total</Text>
                </View>
                <View style={{ width: '10%' }}>
                    <Text style={[styles.h10, styles.textAlignRight, {}]}>{formatCurrencyDisplay(subTotal)}</Text>
                </View>
            </View> */}

            {
                adjustmentDiscountInfo.length > 0 &&
                <View
                    style={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        // paddingVertical: 8,
                    }}
                >
                    <View style={{ width: '80%' }}>
                        <></>
                    </View>

                    <View style={{ width: '10%' }}>
                        <Text style={[styles.h10, styles.textUpperCase, {}]}>
                            {'Discount\n'}

                            {/* {
                            adjustmentDiscountInfo.map(i => {
                                return(
                                    <Text key={i?.discountId} style={styles.textCapitalize}>
                                        {`${i?.discountDescription}\n`}
                                    </Text>
                                )
                            })
                        } */}
                        </Text>
                    </View>

                    <View style={{ width: '11%' }}>
                        {
                            adjustmentDiscountInfo.map(i => {
                                return (
                                    (i?.discountAmount) ?
                                        <Text key={i?.discountId} style={[styles.h10, styles.textAlignRight, {}]}>
                                            {formatCurrencyDisplay(
                                                parseFloat(i?.discountAmount).toFixed(2)
                                            )}
                                        </Text>
                                        :
                                        <Text>{"-"}</Text>
                                )
                            })
                        }
                    </View>
                </View>
            }

            {
                adjustmentTaxInfo.map((i, index) => {
                    return (
                        <View
                            key={index}
                            style={{
                                display: 'flex',
                                flexDirection: 'row',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                // paddingVertical: 8,
                            }}
                        >
                            <View style={{ width: '50%' }}>
                                <></>
                            </View>

                            <View style={{ width: '40%' }}>
                                <Text style={[styles.h10, styles.textUpperCase, styles.textAlignRight, {}]}>
                                    {`Tax : ${i?.taxDescription}\n`}
                                </Text>
                            </View>

                            <View style={{ width: '12%' }}>
                                <Text key={i?.taxId} style={[styles.h10, styles.textAlignRight, {}]}>
                                    {`${i?.taxAmount}\n`}
                                </Text>
                            </View>

                        </View>
                    )
                })
            }

            <View
                style={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    // paddingVertical: 8,
                }}
            >
                <View style={{ width: '80%' }}>
                    <></>
                </View>
                <View style={{ width: '15%' }}>
                    <Text style={[styles.textBold, styles.h10, styles.textUpperCase, {}]}>Total ({currencyAbb})</Text>
                </View>
                <View style={{ width: '10%' }}>
                    <Text style={[styles.textBold, styles.h10, styles.textAlignRight, {}]}>{formatCurrencyDisplay(totalAmount)}</Text>
                </View>
            </View>
        </View>
    )

}

// item receive
export function BodyMainFooterStyle4(props) {

    const {
        data,
        summary
    } = props

    const totalQty = summary?.totalQty ? summary.totalQty.toFixed(2) : 0.00

    return (
        <View
            style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
                alignItems: 'center',
                // paddingVertical: 8,
                paddingTop: 5,
                borderTopColor: '#000',
                borderTopStyle: 'solid',
                borderTopWidth: 1,
            }}
        >
            <View style={{ width: '55%' }}>
                <></>
            </View>
            <View style={{ width: '20%' }}>
                <Text style={[styles.textBold, styles.h10, styles.textUpperCase, {}]}>Total</Text>
            </View>
            <View style={{ width: '35%' }}>
                <Text style={[styles.textBold, styles.h10, {}]}>{totalQty}</Text>
            </View>
        </View>
    )

}

// item transfer
export function BodyMainFooterStyle5(props) {

    const {
        data,
        summary
    } = props

    const totalQty = summary?.totalQty ? summary.totalQty.toFixed(2) : 0.00

    return (
        <View
            style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
                alignItems: 'center',
                // paddingVertical: 8,
                paddingTop: 5,
                borderTopColor: '#000',
                borderTopStyle: 'solid',
                borderTopWidth: 1,
            }}
        >
            <View style={{ width: '50%' }}>
                <></>
            </View>
            <View style={{ width: '13%' }}>
                <Text style={[styles.textBold, styles.h10, styles.textUpperCase, {}]}>Total</Text>
            </View>
            <View style={{ width: '44%' }}>
                <Text style={[styles.textBold, styles.h10, {}]}>{totalQty}</Text>
            </View>
        </View>
    )

}

// delivery trip
export function BodyMainFooterStyle6(props) {

    const {
        data,
        summary
    } = props

    const totalQty = summary?.totalQty ? summary.totalQty.toFixed(2) : 0.00

    return (
        <View
            style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
                alignItems: 'center',
                // paddingVertical: 8,
                paddingTop: 5,
                borderTopColor: '#000',
                borderTopStyle: 'solid',
                borderTopWidth: 1,
            }}
        >
            <View style={{ width: '55%' }}>
                <></>
            </View>
            {/* <View style={{ width: '13%' }}>
                <Text style={[styles.textBold, styles.h10, styles.textUpperCase, {}]}>Total</Text>
            </View>
            <View style={{ width: '45%' }}>
                <Text style={[styles.textBold, styles.h10, {}]}>{totalQty}</Text>
            </View> */}
        </View>
    )

}

// sales CN & DN
export function BodyMainFooterStyle7(props) {

    const {
        data,
        summary
    } = props

    const totalQty = summary?.totalQty ? summary.totalQty.toFixed(2) : 0.00

    return (
        <View
            style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
                alignItems: 'center',
                // paddingVertical: 8,
                paddingTop: 5,
                borderTopColor: '#000',
                borderTopStyle: 'solid',
                borderTopWidth: 1,
            }}
        >
            <View style={{ width: '55%' }}>
                <></>
            </View>
            <View style={{ width: '20%' }}>
                <Text style={[styles.textBold, styles.h10, styles.textUpperCase, {}]}>Total</Text>
            </View>
            <View style={{ width: '30%' }}>
                <Text style={[styles.textBold, styles.h10, {}]}>{totalQty}</Text>
            </View>
        </View>
    )

}

// item relocate
export function BodyMainFooterStyle8(props) {

    const {
        data,
        summary
    } = props

    const totalQty = summary?.totalQty ? summary.totalQty.toFixed(2) : 0.00

    return (
        <View
            style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
                alignItems: 'center',
                // paddingVertical: 8,
                paddingTop: 5,
                borderTopColor: '#000',
                borderTopStyle: 'solid',
                borderTopWidth: 1,
            }}
        >
            <View style={{ width: '30%' }}>
                <></>
            </View>
            <View style={{ width: '20%' }}>
                <Text style={[styles.textBold, styles.h10, styles.textUpperCase, {}]}>Total</Text>
            </View>
            <View style={{ width: '60%' }}>
                <Text style={[styles.textBold, styles.h10, {}]}>{totalQty}</Text>
            </View>
        </View>
    )

}

// transfer requisition
export function BodyMainFooterStyle9(props) {

    const {
        data,
        summary
    } = props

    const totalQty = summary?.totalQty ? summary.totalQty.toFixed(2) : 0.00

    return (
        <View
            style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
                alignItems: 'center',
                // paddingVertical: 8,
                paddingTop: 5,
                borderTopColor: '#000',
                borderTopStyle: 'solid',
                borderTopWidth: 1,
            }}
        >
            <View style={{ width: '60%' }}>
                <></>
            </View>
            <View style={{ width: '20%' }}>
                <Text style={[styles.textBold, styles.h10, styles.textUpperCase, {}]}>Total</Text>
            </View>
            <View style={{ width: '16%' }}>
                <Text style={[styles.textBold, styles.h10, {}]}>{totalQty}</Text>
            </View>
        </View>
    )

}

// item issue & stock take
export function BodyMainFooterStyle10(props) {

    const {
        data,
        summary
    } = props

    const totalQty = summary?.totalQty ? summary.totalQty.toFixed(2) : 0.00

    return (
        <View
            style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
                alignItems: 'center',
                // paddingVertical: 8,
                paddingTop: 5,
                // paddingBottom: 3,
                // paddingBottom: 10,
                // paddingVertical: 10,
                borderTopColor: '#000',
                borderTopStyle: 'solid',
                borderTopWidth: 1,
            }}
        >
            <View style={{ width: '50%' }}>
                <></>
            </View>
            <View style={{ width: '30%' }}>
                <Text style={[styles.textBold, styles.h10, styles.textUpperCase, {}]}>Total</Text>
            </View>
            <View style={{ width: '10%' }}>
                <Text style={[styles.textBold, styles.h10, {}]}>{totalQty}</Text>
            </View>

        </View>
    )

}

